import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getMyStoreApi, updateMyStoreApi, getStoreByIdApi, getStoresApi } from '../api/store.api';

export const STORE_KEYS = {
  mine:   ['store', 'me'],
  byId:   (id) => ['store', id],
  list:   (p)  => ['stores', p],
};

export const useMyStore = () =>
  useQuery({
    queryKey: STORE_KEYS.mine,
    queryFn:  () => getMyStoreApi().then((r) => r.data.data).catch(() => null),
  });

export const useUpdateMyStore = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updateMyStoreApi,
    onSuccess: ({ data }) => {
      toast.success(data.message || 'Store updated');
      qc.invalidateQueries({ queryKey: STORE_KEYS.mine });
    },
    onError: (e) => toast.error(e?.response?.data?.message || 'Failed to update store'),
  });
};

export const useStoreById = (id) =>
  useQuery({
    queryKey: STORE_KEYS.byId(id),
    queryFn:  () => getStoreByIdApi(id).then((r) => r.data.data),
    enabled:  !!id,
  });

export const useStores = (params) =>
  useQuery({
    queryKey: STORE_KEYS.list(params),
    queryFn:  () => getStoresApi(params).then((r) => r.data.data),
  });
